export default __webpack_public_path__ + "static/media/packing.bdd84aab.svg";